import { render } from "./AtomIcon.vue?vue&type=template&id=b12b5372&ts=true"
import script from "./AtomIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/AtomIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b12b5372"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b12b5372', __exports__)) {
    api.reload('b12b5372', __exports__)
  }
  
  module.hot.accept("./AtomIcon.vue?vue&type=template&id=b12b5372&ts=true", () => {
    api.rerender('b12b5372', render)
  })

}


export default __exports__